(ns frontend.view.kpi-reporting.kpi-offer.events
  (:require [frontend.actions.account :as account-actions]
            [frontend.logging :as logging]))

(defn update-preferences [new-prefs]
  (let [data {:account/preference new-prefs}]
    (account-actions/*->update-preferences data
                                           (partial logging/unimplemented "success updating preferences")
                                           (partial logging/error "Error updating preferences"))))
